<template>
  <div>
    <Page :path="$route.path" />
  </div>
</template>

<script>
export default {
  name: 'CatchAll'
}
</script>
